import React from 'react';
import { Slide } from 'react-reveal';

const Experience = () => {
    return (

        <div id='experience' className="py-10  lg:mx-24 sm:mx-2 px-5 mt-8 ">
            <h2 className="text-3xl font-bold text-center pb-12">
                Experience
            </h2>

            <div className="flex  justify-center items-center lg:flex-row sm:flex flex-col">
                <Slide left>
                    <div className='flex flex-col lg:w-7/12 sm:w-full '>
                        <div className="flex-1 shadow-xl lg:px-10 py-8 sm:py-5  px-5">
                            <div className='flex flex-row justify-between mb-12 '>
                                <h2 className=" font-bold lg:text-2xl sm:text-xl">
                                    Oculin Tech BD Ltd.
                                </h2>
                                <h3 className="lg:text-xl sm:text-lg">
                                    Jan 2022 - Present
                                </h3>
                            </div>
                            <h3 className="text-xl lg:py-3 sm:py-0">
                                Jr. Executive - Software Development
                            </h3>
                            <ul>
                                <li>• Working closely in two modules of Oracle Utilities software: <br />
                                    (i) MDM (Meter Data Management)
                                    (ii) CC&B (Customer Care & Billing) </li>
                                <li>• Performing the MDS (Master Data Sync) process
                                    Data) in MDM
                                </li>
                                <li>• Polling the files from FTP location to MDM through SOA middleware
                                </li>
                                <li>• Running the batches for finalizing the IMDs (Initial Measurement
                                </li>
                                <li>• Handling To Do-s (Error and Exception)
                                </li>
                                <p className='font-bold py-3'>Projects:</p>
                                <p> Supply, Installation, Testing & Commissioning of Smart Pre-Payment
                                    Meter with Related Services On Turn Key Basis for NESCO Ltd. -
                                    Package 1 and 2
                                    Design, Supply, Installation, Testing & Commissioning of Advanced
                                    Metering Infrastructure (AMI) with Smart Metering System on Turnkey
                                    Basis for DPDC</p>
                            </ul>


                        </div>
                        <div className="flex-1 shadow-xl lg:px-10 py-8 mt-5 sm:py-5  px-5">
                            <div className='flex flex-row justify-between'>
                                <h2 className=" font-bold lg:text-2xl sm:text-xl">
                                    Oculin Tech BD Ltd.
                                </h2>
                                <h3 className="lg:text-xl sm:text-lg">
                                    Jun 21 - Dec 21
                                </h3>
                            </div>
                            <h3 className="text-xl lg:py-3 sm:py-0">
                                Intern
                            </h3>
                            <ul>
                                <li></li>
                            </ul>


                        </div>

                    </div>
                </Slide>

                <Slide right>
                    <div className="flex-1 lg:px-10 py-24 mx-5 sm:mx-2 ">
                        <h2 className=" font-bold text-center lg:py-5 text-2xl sm:text-xl"> Professional Training</h2>
                        <div className='flex flex-col sm:w-full'>
                            <div className='shadow-xl mb-12  px-5 py-3'>
                                <h3 className="font-semibold pt-8 lg:text-xl  sm:text-lg">Complete Web Development</h3>
                                <p>Programming Hero</p>
                                <p> Dec 2021 - Present</p>
                            </div>
                            <div className='shadow-xl px-5 py-5'>

                                <h3 className="font-semibold lg:text-xl  sm:text-lg">Web Designer Trainee</h3>
                                <p> Pondit, Chattogram</p>
                                <p> May 2019 - Nov 2019</p>
                            </div>
                        </div>


                    </div>
                </Slide>

            </div>
        </div >
        // <div>
        //     <h2 class="heading">Experience</h2>
        // <div class="education-block">
        //     <h3>Oculin Tech BD Ltd.</h3>
        //     <span class="education-date">Jan 2022 - Present</span>
        //     <h4>Jr. Executive - Software Development</h4>
        //     <p>
        //         Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in iaculis ex. Etiam volutpat laoreet urna. Morbi ut tortor nec nulla commodo malesuada sit amet vel lacus. Fusce eget efficitur libero. Morbi dapibus porta quam laoreet placerat.
        //     </p>
        // </div>

        // <div class="">
        // <h3>Oculin Tech BD Ltd.</h3>
        //     <span class="education-date">June 2021 - Dec 2022</span>
        //     <h4>Intern</h4>
        //     <ul>
        //         <li>
        //             Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        //         </li>
        //         <li>
        //             Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        //         </li>
        //         <li>
        //             Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        //         </li>
        //     </ul>
        // </div>
        // </div>
    );
};

export default Experience;